import { Matrix2DInt } from './util.js'

class LevelConfig {
    constructor(monthInfo, weekHintsArr, dayOfWeekHintsArr, restHintIdx2Ds, eventHintIdx2Ds) {
        this.monthInfo = monthInfo;
        this.weekHintsArr = weekHintsArr;
        this.dayOfWeekHintsArr = dayOfWeekHintsArr;
        this.restHintIdx2Ds = restHintIdx2Ds;
        this.eventHintIdx2Ds = eventHintIdx2Ds;
    }
}

class MonthInfo {
    constructor(displayName,  monthStartIdx1D, numDaysInMonth, numDaysPrevMonth) {
        this.displayName = displayName;
        this.monthStartIdx1D = monthStartIdx1D;
        this.numDaysInMonth = numDaysInMonth;
        this.numDaysPrevMonth = numDaysPrevMonth;
    }
}

/* seems like I would like typescript */

const decemberMonth = new MonthInfo('December 2022', 4, 31, 30);

const decemberLevelConfigAtt1 = new LevelConfig(
    decemberMonth,
    [null, 5, 5, null, null],
    [1, null, 2, null, 4, 3, null],
    [ new Matrix2DInt(2, 6)],
    [ new Matrix2DInt(1, 3), new Matrix2DInt(2, 2), new Matrix2DInt(2, 4)]
);

const januaryMonth = new MonthInfo('January 2023', 0, 31, 31);

const januaryConfigAtt1 = new LevelConfig(
    januaryMonth,
    [null, null, 5, 5, null],
    [null, 3, 4, null, 2, null, 1],
    [ new Matrix2DInt(2, 0)],
    [ new Matrix2DInt(3, 3), new Matrix2DInt(2, 2), new Matrix2DInt(2, 4)]
);


const decemberLevelConfigAtt2 = new LevelConfig(
    decemberMonth,
    [3, 5, 4, null, null],
    [3, 3, null, 0, 4, 4, null],
    [ new Matrix2DInt(1, 0)],
    [ new Matrix2DInt(1, 4), new Matrix2DInt(3, 2)]
);

export const levelConfig = januaryConfigAtt1;
